<template>
  <div>
    <div id="map"></div>

    <div class="card">
      <div class="header">地图标签管理</div>
      <div class="body">
        <div v-if="visible === false">
          <div class="right" style="margin-bottom: 12px">
              <ButtonField text="添加" primary @click="add"/>
          </div>
            <Tablelist style="margin-top: 1rem"
                       :showCheckbox="false"
                       :list="list"
                       :columns="tableColumns"
                       :totalSize="totalSize"
                       :totalPages="totalPages"
                       :pageNum="pageNum"
                       :pageSize="pageSize"
                       @page-change="onChange"
            >
                <template #template-method="{ item }">
                    <span v-if="item.method === 'fill'">填充</span>
                    <span v-if="item.method === 'outline'">描边</span>
                </template>
                <template v-slot:actions="{ item }">
                    <a-space>
                        <a href="#" @click.prevent="edit(item)">编辑</a>
                        <a href="#" class="danger" @click.prevent="deleteText(item)">删除</a>
                    </a-space>
                </template>
            </Tablelist>
        </div>
        <div v-else>
          <form :form="form">
              <InputField style="margin: 1rem 0.1rem 0.1rem 0;" label="标签名称" labelWidth="20%" inputWidth="80%"
                          type="text" id="name" :modelValue="form.name" placeholder="标签名称" required
                          @update:modelValue="(value) => handleModelValueUpdate('name', value)"/>
              <SelectField style="margin: 1rem 0.1rem 0.1rem 0;" :options="methodList"
                           label="绘制方式" labelWidth="20%" required
                           :modelValue="form.method" id="method" placeholder="绘制方式"
                           @update:modelValue="(value) => handleModelValueUpdate('method', value)"/>
              <InputField style="margin: 1rem 0.1rem 0.1rem 0;" label="颜色" labelWidth="20%" inputWidth="80%"
                          type="text" id="color" :modelValue="form.color" placeholder="颜色" required
                          @update:modelValue="(value) => handleModelValueUpdate('color', value)"/>

              <InputField style="margin: 1rem 0.1rem 0.1rem 0;" label="坐标范围" labelWidth="20%" inputWidth="80%"
                          type="text" id="locations" :modelValue="form.locations" placeholder="坐标范围" required disabled
                          @update:modelValue="(value) => handleModelValueUpdate('locations', value)"/>
              <div class="tip">请点击右侧地图获取</div>

              <div class="center" style="margin-top: 1rem;">
                <a-space>
                    <ButtonField text="取消" @click="cancel" secondary />
                    <ButtonField :text="form.id ? '编辑' : '添加'" primary @click="handleSubmit"/>
                </a-space>
              </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { fetchList, remove, add, edit } from "@/api/setting/map-label";

import { Scene } from "@antv/l7";
import { GaodeMapV2 } from "@antv/l7-maps";

export default {
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      totalSize: 0,
      totalPages: 0,
      pageNum: 1,
      pageSize: 10,
      tableColumns: [
          {
              key: 'name',
              title: '名称',
              field: 'name',
              infotype: 'text'
          },
          {
              key: 'method',
              title: '绘制方式',
              field: 'method',
              infotype: 'template',
          },
          {
              key: 'color',
              title: '颜色',
              field: 'color',
              infotype: 'text',
          },
          {
              key: 'actions',
              title: '操作',
              infotype: 'template',
          }
      ],
      form: {
          name:null,
          method:null,
          color:null,
          locations:null
      },
      editingText: {},
      visible: false,
      selectedLnglat: [],
      methodList:[
          {name:'描边',value:'outline'},
          {name:'填充',value:'fill'},
      ]
    };
  },

  mounted() {
    const map = this.initMap();
    this.scene = new Scene({
      id: "map",
      logoVisible: false,
      map: new GaodeMapV2({
        mapInstance: map,
      }),
    });
    this.getList();
  },

  beforeDestroy() {
    // this.scene?.removeAllLayer();
    // this.scene?.removeAllMakers();
    this.scene?.destroy();

    this.map?.clearMap();
    this.map?.destroy();
  },

  methods: {
    handleModelValueUpdate(fieldName, value) {
        this.form[fieldName] = value;
    },
    initMap() {
      const { AMap } = window;
      if (!AMap) {
        return;
      }
      var map = new AMap.Map("map", {
        center: [118.536766,32.993047],
        zoom: 15,
        // mapStyle: "amap://styles/f3c7464cbaf52050e35d00dc506f4069",
        mapStyle: "amap://styles/light",
      });

      AMap.plugin(["AMap.Scale", "AMap.HawkEye", "AMap.MapType"], function () {
        map.addControl(new AMap.Scale());
        map.addControl(new AMap.MapType());
        map.addControl(new AMap.HawkEye({ isOpen: true ,mapStyle: "amap://styles/light",}));

      });

      this.map = map;

      map.on("click", this.onMapClick);

      return map;
    },
    onMapClick(e) {
      if (this.visible) {
        const { AMap } = window;
        const lnglat = {
          lng: e.lnglat.getLng(),
          lat: e.lnglat.getLat(),
        };
        this.selectedLnglat.push(lnglat);
        // this.form.setFieldsValue({
        //   locations: this.selectedLnglat
        //     .map((item) => item.lng + "," + item.lat)
        //     .join(";"),
        // });
        this.form.locations = this.selectedLnglat
            .map((item) => item.lng + "," + item.lat)
            .join(";");

        var marker = new AMap.Marker({
          position: new AMap.LngLat(lnglat.lng, lnglat.lat),
        });
        marker.on("click", this.onMarkerClick);

        if (this.markers) {
          this.markers.push(marker);
        } else {
          this.markers = [marker];
        }
        this.map.add(marker);
      }
    },
    onMarkerClick(e) {
      console.log("e", e);
      const { lng, lat } = e.target._position;
      console.log("selectedLnglat", this.selectedLnglat, lng, lat);

      const index = this.selectedLnglat.findIndex(
        (item) => parseFloat(item.lng) === lng && parseFloat(item.lat) === lat
      );
      console.log("index", index, this.markers);
      if (index !== -1) {
        this.selectedLnglat.splice(index, 1);

        // this.form.setFieldsValue({
        //   locations: this.selectedLnglat
        //     .map((item) => item.lng + "," + item.lat)
        //     .join(";"),
        // });
        this.form.locations = this.selectedLnglat
            .map((item) => item.lng + "," + item.lat)
            .join(";");

        const marker = this.markers[index];
        if (marker) {
          this.map?.remove(marker);
          this.markers.splice(index, 1);
        }
      }
    },
    getList() {
      this.loading = true;
      fetchList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      })
        .then((res) => {
          if (Array.isArray(res.list)) {
            this.list = Object.freeze(res.list);
            this.totalSize = res.totalSize;
            this.totalPages = res.totalPages;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onChange(pagination) {
      this.pageNum  = pagination;
      this.pageSize = 10;
      this.getList();
    },
    add() {
      this.visible = true;
    },
    edit(text) {
      const { AMap } = window;
      this.editingText = text;
      this.form = this.editingText;
      this.visible = true;
      this.selectedLnglat = text.locations.split(";").map((item) => {
        const arr = item.split(",");
        return {
          lng: arr[0],
          lat: arr[1],
        };
      });

      const markers = this.selectedLnglat.map((lnglat) => {
        var marker = new AMap.Marker({
          position: new AMap.LngLat(lnglat.lng, lnglat.lat),
        });

        marker.on("click", this.onMarkerClick);

        return marker;
      });

      this.markers = markers;

      this.map.add(markers);
    },
    deleteText(text) {
      const that = this;
      this.$confirm({
        title: "确认要删除吗？",
        onOk() {
          remove({
            id: text.id,
          }).then(() => {
            that.getList();
          });
        },
      });
    },
    cancel() {
      this.form = {};
      this.editingText = {};
      this.map?.clearMap();
      this.selectedLnglat = [];
      this.markers = [];
      this.visible =false;
      this.isSubmitting = false;
    },
    handleSubmit() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      if (!this.form.name) {
          this.$message.error('标签名称不能为空');
          this.isSubmitting = false;
          return;
      }
      if (!this.form.method) {
          this.$message.error('绘制方式不能为空');
          this.isSubmitting = false;
          return;
      }
      if (!this.form.color) {
          this.$message.error('颜色不能为空');
          this.isSubmitting = false;
          return;
      }
      if (!this.form.locations) {
          this.$message.error('坐标范围不能为空');
          this.isSubmitting = false;
          return;
      }

      if (this.editingText.id) {
        edit({
          id: this.editingText.id,
          ...this.form,
        }).then(() => {
          this.getList();
          this.cancel();
        });
      } else {
        add({
          ...this.form,
        }).then(() => {
          this.getList();
          this.cancel();
        });
      }
    }
  },
};
</script>
<style lang="less" scoped>
#map {
  position: fixed;
  top: -50px;
  left: 0;
  right: 0;
  bottom: -20px;
  z-index: 10;
}

.card {
  position: fixed;
  top: 10vh;
  left: 1vw;
  width: 30vw;
  z-index: 99;
  background-color: var(--detail-bgcolor);
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  border: 1px solid #073d3c;
  .header {
    background-color: var(--default-bgcolor);
    color: #00ff96;
    font-weight: bold;
    padding: 1vh 1vw;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .body {
    padding: 2vh 1vw;

    .tip {
      font-size: 12px;
      color: #999;
    }
  }
}
</style> 